import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSun, faMoon, faCloudSun, faCloudMoon } from '@fortawesome/free-solid-svg-icons';
import { HeaderLeft, HeaderAvatar, TitleSection, MainTitle, Subtitle } from './Styles';
import { getGreetingTime, TimeOfDay } from './Constant';
import type { GreetingProps } from './types';

const TIME_THEME: Record<TimeOfDay, { icon: typeof faSun; color: string; bg: string; bgDark: string }> = {
  morning: { icon: faCloudSun, color: '#fa8c16', bg: '#fff4e5', bgDark: 'rgba(250, 140, 22, 0.15)' },
  afternoon: { icon: faSun, color: '#f59f00', bg: '#fff8e1', bgDark: 'rgba(245, 159, 0, 0.15)' },
  evening: { icon: faCloudMoon, color: '#7048e8', bg: '#f3f0ff', bgDark: 'rgba(112, 72, 232, 0.18)' },
  night: { icon: faMoon, color: '#4263eb', bg: '#edf2ff', bgDark: 'rgba(66, 99, 235, 0.18)' },
};

const Greeting: React.FC<GreetingProps> = ({ name }) => {
  const timeOfDay = getGreetingTime();
  const theme = TIME_THEME[timeOfDay];

  return (
    <HeaderLeft>
      <HeaderAvatar $color={theme.color} $bg={theme.bg} $bgDark={theme.bgDark}>
        <FontAwesomeIcon icon={theme.icon} />
      </HeaderAvatar>
      <TitleSection>
        <MainTitle>
          Welcome back, {name}! <span role="img" aria-label="waving hand">👋</span>
        </MainTitle>
        <Subtitle>Here&apos;s an overview of your store performance today.</Subtitle>
      </TitleSection>
    </HeaderLeft>
  );
};

export default Greeting;
